/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateGlobalConfigurationRequest } from '../../models/create-global-configuration-request';
import { GlobalConfigurationDto } from '../../models/global-configuration-dto';

export interface CreateGlobalConfiguration$Params {
      body: CreateGlobalConfigurationRequest
}

export function createGlobalConfiguration(http: HttpClient, rootUrl: string, params: CreateGlobalConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<GlobalConfigurationDto>> {
  const rb = new RequestBuilder(rootUrl, createGlobalConfiguration.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GlobalConfigurationDto>;
    })
  );
}

createGlobalConfiguration.PATH = '/v0/globalConfigurations/{id}';
